module.exports = __webpack_public_path__ + "static/media/6.155f8967.jpg";